export default __webpack_public_path__ + "img/470915e7810b0299eb8b3d35242e79e8.svg";